import { POINT_HUB_DEDUPE_MAX_ENTRIES, POINT_HUB_DEDUPE_TTL_MS } from './constants';
import { getPointHubRuntimeCache } from './runtime-cache';
import type { NormalizedMeetingBookingSessionRecommendEvent } from './types';

const getReportKey = (event: NormalizedMeetingBookingSessionRecommendEvent): string => {
  return event.eventId || `${event.sessionId}|${event.result}|${event.occurredAt}`;
};

const pruneReports = (now: number): void => {
  const reports = getPointHubRuntimeCache().reports;
  reports.forEach((entry, key) => {
    if (now - entry.updatedAt >= POINT_HUB_DEDUPE_TTL_MS) reports.delete(key);
  });
  while (reports.size >= POINT_HUB_DEDUPE_MAX_ENTRIES) {
    const oldest = reports.keys().next();
    if (oldest.done) break;
    reports.delete(oldest.value);
  }
};

export const acquirePointHubReport = (
  event: NormalizedMeetingBookingSessionRecommendEvent,
  identityKey: string,
  now = Date.now()
): string | null => {
  const cache = getPointHubRuntimeCache();
  if (cache.identityKey !== identityKey) {
    cache.identityKey = identityKey;
    cache.reports.clear();
  }
  pruneReports(now);
  const key = getReportKey(event);
  if (cache.reports.has(key)) return null;
  cache.reports.set(key, { state: 'reporting', updatedAt: now });
  return key;
};

export const finishPointHubReport = (key: string, now = Date.now()): void => {
  const entry = getPointHubRuntimeCache().reports.get(key);
  if (!entry) return;
  entry.state = 'finished';
  entry.updatedAt = now;
};

export const clearPointHubReports = (): void => {
  const cache = getPointHubRuntimeCache();
  cache.identityKey = null;
  cache.reports.clear();
};
